import { AxiosError, AxiosInstance } from 'axios';
import { QueryClient } from '@tanstack/react-query';

export const login = (loginUrl: string) => window.location.replace(loginUrl);

export const getToken = async (code: string, abortController: AbortController, apiClient: AxiosInstance) => {
  try {
    const response = await apiClient.post('/cognito/callback', { code }, { signal: abortController.signal });
    return response?.data;
  } catch (error) {
    throw new Error((error as AxiosError).message);
  }
};

export const logout = async (apiClient: AxiosInstance, queryClient: QueryClient) => {
  const refreshToken = localStorage.getItem('refreshToken');
  // invalidate the refresh token
  await apiClient.post('/revoke-token', refreshToken);
  // remove tokens from local storage
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('accessToken');
  // remove auth token from auth header
  // eslint-disable-next-line no-param-reassign
  apiClient.defaults.headers.common.Authorization = undefined;
  // remove user data from cache
  queryClient.invalidateQueries(['current-user']);
};
